import { subscriptionsMetadataAdapter } from "./slice";

import type { RootState } from "../store";

const getState = (state: RootState) => state.subscriptionsMetadata;

export const { selectById: selectSubscriptionById } =
  subscriptionsMetadataAdapter.getSelectors(getState);
